import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Address } from '../../models/address';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AbstractForm } from '../../utils/abstract-form';
import { State } from '../../models/state';
import { LoggerService } from 'src/app/core/logger/logger.service';
import { filter, debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { GeneralService } from '../../services/general.service';
import { Subscription } from 'rxjs';
import { MaskApplierService, MaskPipe } from 'ngx-mask';

@Component({
    selector: 'address',
    templateUrl: './address.component.html'
})
export class AddressComponent extends AbstractForm implements OnInit, OnDestroy {

    @Input() address: Address = new Address;
    @Input() type: string; 
    @Input() formDisabled: boolean = false;
    @Input() mapActive: boolean = true;
    @Input() mapHeight: string = '322px';
    @Input() required: boolean = false;
    @Input() colSize: [] = [];

    states: State[];



    geoLocation: any = {};
    longitude: any = -48.61384286313532;
    latitude: any = -27.09398172060979;

    generalDataSubscription:Subscription;
    subscribed:Subscription;

    constructor(
        formBuilder: FormBuilder, 
        logger: LoggerService,
        private generalService: GeneralService,
        protected ms : MaskApplierService
    ) {
        super(formBuilder, logger,false);
    }
    ngOnInit(){
        this.generalDataSubscription = this.generalService.settingsLoad$.subscribe(result => {
            this.states = result.states;
        });
        this.formDefault();
        this.endLoading();
        if(this.formDisabled){
            this.enableEdit(false);
        } else {
            this.enableEdit(true, [], ['cityName','state']);
            this.subscribeOnChange();
        }
    }

    ngOnDestroy(){
        this.generalDataSubscription?.unsubscribe();
    }


    buildFormGroup(): FormGroup {
        this.states = this.generalService.getGeneralData().states;
        
        if(!this.address?.zipcode)
            this.address = new Address;

        this.longitude = typeof this.address?.getLongitude != 'undefined'? this.address?.getLongitude() : '';
        this.latitude = typeof this.address?.getLatitude != 'undefined'? this.address?.getLatitude() : '';

        let required = this.required? [Validators.required] : [];
        
        return this.formBuilder.group({
            zipcode: [this.cepMask(this.address?.zipcode || ''), [Validators.minLength(8)].concat(required)],
            state: [{value: State.getStateByCode(this.states, this.address?.city?.state || null), disabled: true}, [Validators.minLength(1)].concat(required)],
            cityId: [this.address?.city?.id || '', [Validators.minLength(1)].concat(required)], 
            cityName: [this.address?.city?.name || '', [Validators.minLength(1)].concat(required)],
            district: [this.address?.district || '', [Validators.minLength(3)].concat(required)],
            street: [this.address?.street || '', [Validators.minLength(3)].concat(required)],
            number: [this.address?.number || '', [Validators.minLength(1)].concat(required)],
            complement: [this.address?.complement || ''],
            longitude: [this.address?.longitude || ''],
            latitude: [this.address?.latitude || '']
        });
    }

    subscribeOnChange() {
        this.subscribed?.unsubscribe();

        this.subscribed = this.getControl('zipcode').valueChanges
            .pipe(
                filter(text => typeof text === 'string' && text.replace('-', '').replace('.', '').length == 8),
                debounceTime(250),
                distinctUntilChanged())
            .subscribe(value => {
                /*
                if(!this.eventEmit){
                    this.eventEmit = true;
                    return;
                }*/

                this.generalService.findCep(value).then(value => {
                    value = value[0] || value;

                    this.address.city.id = value['city_id'];
                    this.address.city.name = value['city_name'];
                    this.address.zipcode = value['zipcode'];
                    this.address.city.state = State.getStateByCode(this.states, value['state_id']);
                    this.address.district = value['district'] === null ? '' : value['district'];
                    this.address.street = value['street'] === null ? '' : value['street'];
                    this.updateControls(true);
                    this.updateMap();
                }).catch(error => {
                    //this.enableEdit(false, ['zipcode','street']);
                    this.enableEdit(false, ['zipcode','district','street','number','complement']);
                    this.logger.warning(['subscribeOnChange', 'CEP não encontrado'], error);
                    this.getControl('zipcode').setErrors({ invalid: true, msg: 'CEP não encontrado' });
                });
            });
        
        ['state', 'street', 'cityName', 'district', 'complement', 'number'].forEach(item => {
            this.getControl(item).valueChanges
                .pipe(
                    filter(text => this.getControl(item).dirty == true),
                    distinctUntilChanged()
                ).subscribe(value => {
                    this.updateMap(value, item);
                    this.eventEmitter.emit('dirty');
                });
        });

    }

    // next(msg: any) {
    //     if (msg instanceof Person) {
    //         this.address = msg.address
    //     }
    //     this.updateControls();
    //     super.next(msg);
    // }


    cepMask(vl){
        if(!vl || !vl?.length)
            return vl;

        vl = vl.replace('-','').replace('.','');

        let mask = new MaskPipe(this.ms);
        let r = mask.transform(vl, '99.999-999');

        return r;
    }

    updateMap(value = false, item: any = false) {
        this.geoLocation = this.updateObjectAddress();
    }
    
    addressUpdate(event) {
              
        if (typeof event?.user != 'undefined' || this.getControlValue('longitude') == '0.000000') {
            this.setControlValue('longitude', event.lng);
            this.setControlValue('latitude', event.lat);
            this.eventEmitter.emit('dirty');
        }
    }

    updateControls(zipLoad = false) {
        console.log(this.states, this.address, this.address.city.state?.state_id, this.address.city.state?.state_id? this.address.city.state : State.getStateByCode(this.states, this.address?.city?.state || 0));
        if(!!this.states?.length)
            this.setControlValue('state', this.address.city.state?.state_id? this.address.city.state : State.getStateByCode(this.states, this.address?.city?.state || 0));

        this.setControlValue('cityId', this.address.city.id);
        this.setControlValue('cityName', this.address.city.name);

        this.setControlValue('zipcode', this.cepMask(this.address?.zipcode || ''));

        if(this.address.district || !zipLoad)
            this.setControlValue('district', this.address.district);

        if(this.address.street || !zipLoad)
            this.setControlValue('street', this.address.street);

        if(this.address.number || !zipLoad)
            this.setControlValue('number', this.address.number);

        if(this.address.complement || !zipLoad)
            this.setControlValue('complement', this.address.complement);

        this.setControlValue('longitude', this.address.longitude);
        this.setControlValue('latitude', this.address.latitude);


        this.enableEdit(!this.formDisabled, [],  ['cityName','state']);
        this.eventEmitter.emit('dirty');
        //this.formGroup?.updateValueAndValidity();
        
    }

    updateObject(): any {
        this.address.zipcode = this.getControlValue('zipcode').replace(/[^0-9]+/g, "");
        this.address.city.id = this.getControlValue('cityId');
        this.address.city.state = this.getControlValue('state');
        this.address.city.name = this.getControlValue('cityName');
        this.address.district = this.getControlValue('district');
        this.address.street = this.getControlValue('street');
        this.address.number = this.getControlValue('number');
        this.address.complement = this.getControlValue('complement');
        this.address.longitude = this.getControlValue('longitude');
        this.address.latitude = this.getControlValue('latitude');
        return this.address;
    }

    updateObjectAddress(): any {
        return {
            zipcode: this.validateNull(this.getControlValue('zipcode').replace(/[^0-9]+/g, "")),
            stateId: this.getControlValue('state') === null ? null : this.getControlValue('state')?.state_id,
            countryId: this.getControlValue('state') === null ? null : this.getControlValue('state').country_id,
            state: this.getControlValue('state') === null ? null : this.getControlValue('state').state_name,
            country: this.validateNull('Brazil'),
            cityId: this.validateNull(this.getControlValue('cityId')),
            city: this.validateNull(this.getControlValue('cityName')),
            district: this.validateNull(this.getControlValue('district')),
            street: this.validateNull(this.getControlValue('street')),
            complement: this.validateNull(this.getControlValue('complement')),
            number: this.validateNull(this.getControlValue('number')),
            longitude: this.longitude,
            latitude: this.latitude,
            location : {lon: this.longitude, lat:this.latitude}
        };
    }

    controlChange(){
        this.eventEmitter.emit('dirty');
    }

    validateNull(str) {
        return (str === null || str === undefined || (typeof str == 'string' && !str.trim().length)) ? null : str;
    }

    isEditEnabled() {
        return this.address.zipcode != '' && this.address.zipcode != null;
    }

    zipcodeIsValid(){
        return !this.getControl('zipcode')?.value? false : this.getControl('zipcode').value.replace('-', '').replace('.', '').length == 8;
    }

    compareFnState(c1: any, c2: any): boolean {
        if(c2 === null)
            return false;

        return c1?.state_id == c2?.state_id || c1?.state_id == c2;
    }
}